import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Guard against browser-level sandbox IndexedDB and Firestore Quota resource-exhausted errors
if (typeof window !== 'undefined') {
  // Intercept console.error and console.warn to suppress noisy Firebase SDK logs
  // (e.g. quota limits, and idle stream timeouts) that bypass window.onerror
  const originalConsoleError = console.error;
  console.error = function (...args) {
    const msg = args.map(a => String(a)).join(' ');
    
    // Check for idle stream / connection dropped which is benign and auto-reconnects
    if (
      msg.includes('Disconnecting idle stream') ||
      msg.includes('Timed out waiting for new targets') ||
      msg.includes('CANCELLED: Disconnecting')
    ) {
      return; // Suppress benign grpc idle timeout
    }

    if (
      msg.includes('resource-exhausted') ||
      msg.includes('Quota limit exceeded') ||
      msg.includes('Quota exceeded') ||
      msg.includes('maximum backoff delay') ||
      msg.includes('free tier database')
    ) {
      try {
        localStorage.setItem(
          'dojapao_firestore_quota_exhausted',
          JSON.stringify({ timestamp: Date.now() })
        );
      } catch (e) {}
      return; // Suppress
    }
    originalConsoleError.apply(console, args);
  };

  const originalConsoleWarn = console.warn;
  console.warn = function (...args) {
    const msg = args.map(a => String(a)).join(' ');
    
    // Check for idle stream / connection dropped
    if (
      msg.includes('Disconnecting idle stream') ||
      msg.includes('Timed out waiting for new targets') ||
      msg.includes('CANCELLED: Disconnecting')
    ) {
      return; // Suppress benign grpc idle timeout
    }

    if (
      msg.includes('resource-exhausted') ||
      msg.includes('Quota limit exceeded') ||
      msg.includes('Quota exceeded') ||
      msg.includes('maximum backoff delay') ||
      msg.includes('free tier database')
    ) {
      return; // Suppress
    }
    originalConsoleWarn.apply(console, args);
  };

  window.addEventListener('unhandledrejection', (event) => {
    const reasonStr = String(event.reason?.message || event.reason || '');
    if (
      reasonStr.includes('indexedDB') ||
      reasonStr.includes('backing store') ||
      reasonStr.includes('resource-exhausted') ||
      reasonStr.includes('Quota limit exceeded') ||
      reasonStr.includes('Quota exceeded')
    ) {
      try {
        localStorage.setItem(
          'dojapao_firestore_quota_exhausted',
          JSON.stringify({ timestamp: Date.now() })
        );
      } catch (e) {}
      event.preventDefault();
    }
  });

  window.addEventListener('error', (event) => {
    const msg = String(event.message || '');
    if (
      msg.includes('indexedDB') ||
      msg.includes('backing store') ||
      msg.includes('resource-exhausted') ||
      msg.includes('Quota limit exceeded') ||
      msg.includes('Quota exceeded')
    ) {
      try {
        localStorage.setItem(
          'dojapao_firestore_quota_exhausted',
          JSON.stringify({ timestamp: Date.now() })
        );
      } catch (e) {}
      event.preventDefault();
    }
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
